module.exports = __webpack_public_path__ + "img/1_022.0b8db5ab.jpg";